import React from 'react';
import {concepts} from "fearless-common";
import useAuth from "../../components/hooks/useAuth";
import {Pages} from "../../components/layout";
import Fold from "../../components/layout/Fold";
import GettingStarted from "../../components/GettingStarted";
import background from '../../assets/images/backgrounds/adventureres.jpg';
import styles from './LoginLanding.module.scss'

/**
 * The view the user arrives at after logging in.
 */
export default function LoginLanding() {
    const { user } = useAuth();

    return (
        <Pages.Base>
            <Fold
              className={`bg-lightest text-start p-5 ${styles.LoginLanding}`}
              fullHeight
              backgroundImage={background}
            >
                <div className="ps-3">
                    <div className="text-white text-start mb-3">{concepts.Photo51}</div>
                    <h1 className="text-white text-start mb-5">Welcome,<br/>{user?.first_name}!</h1>
                </div>
                <GettingStarted />
            </Fold>
        </Pages.Base>
    );
}
